import { preventDefault, preventScrollKeys } from "./disableScroll";

function enableScroll() {
  document.body.style.overflow = "";
  window.removeEventListener("wheel", preventDefault);
  window.removeEventListener("touchmove", preventDefault);
  window.removeEventListener("keydown", preventScrollKeys);
}

export default enableScroll;
